import api, { getReq } from 'api';
import { fetchCompanyBySlug } from 'store/company';

const unwrap = (res) => res.data.data;

export const fetchFca = async (profileId) =>
    unwrap(await api.get(`/profiles/${profileId}/fca`));

export const saveFca = async (profileId, details) =>
    unwrap(await api.put(`/profiles/${profileId}/fca`, details));

export const removeFca = async (profileId) =>
    (await api.delete(`/profiles/${profileId}/fca`)).data;

export const fetchFcaQueue = async ({
    state = 'pending',
    page = 1,
    size = 20,
}) => unwrap(await api.get('/fca/queue', { params: { state, page, size } }));

export const fetchFcaCsv = async () =>
    (await api.get('/fca/export', { responseType: 'blob' })).data;

export const approveFca = async (profileId, decision) =>
    unwrap(await api.post(`/profiles/${profileId}/fca/approve`, decision));

export const recheckFca = async (profileId) =>
    (await api.post(`/profiles/${profileId}/fca/recheck`)).data;

export const rejectFca = async (profileId, decision) =>
    unwrap(await api.post(`/profiles/${profileId}/fca/reject`, decision));

// A failed refresh only delays the label change until the next page load.
export const refreshProfile = (dispatch, slug) =>
    getReq(`/profiles/slug/${slug}`)
        .then(({ data }) => {
            if (data?.data?.id)
                dispatch(fetchCompanyBySlug.fulfilled(data.data));
        })
        .catch(() => {});
